import { render, staticRenderFns } from "./Lokasi.vue?vue&type=template&id=853bc8ec&"
import script from "./Lokasi.vue?vue&type=script&lang=js&"
export * from "./Lokasi.vue?vue&type=script&lang=js&"
import style0 from "./Lokasi.vue?vue&type=style&index=0&id=853bc8ec&prod&lang=css&"
import style1 from "./Lokasi.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports